import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/kiko-run',
    name: 'DetailKikoRun',
    component: () => import('../views/KikoRun.vue')
  },
  {
    path: '/parade-live',
    name: 'DetailParadeLive',
    component: () => import('../views/ParadeLive.vue')
  },
  {
    path: '/digital-career',
    name: 'DetailDigitalCareer',
    component: () => import('../views/DigitalCareer.vue')
  },
  {
    path: '/nyapit-cuan',
    name: 'DetailNyapit',
    component: () => import('../views/NyapitCuan.vue')
  },
  {
    path: '/visions-plus',
    name: 'DetailVisions',
    component: () => import('../views/VisionsPlus.vue')
  },
  {
    path: '/tech-forum',
    name: 'DetailForum',
    component: () => import('../views/TechForum.vue')
  },
  {
    path: '/content-creator',
    name: 'DetailContent',
    component: () => import('../views/ContentCreator.vue')
  },
  {
    path: '/virtual-hangout',
    name: 'DetailVirtual',
    component: () => import('../views/VirtualHangout.vue')
  },
  {
    path: '/motion-tech',
    name: 'DetailMotion',
    component: () => import('../views/MotionTech.vue')
  },
  {
    path: '/rcti-plus',
    name: 'DetailRcti',
    component: () => import('../views/RctiPlus.vue')
  },
  {
    path: '/csr-mnc',
    name: 'DetailCsr',
    component: () => import('../views/CsrMnc.vue')
  },
  {
    path: '/onair-concert',
    name: 'DetailOnAir',
    component: () => import('../views/OnAirConcert.vue')
  }
]

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior (to, from, savedPosition) {
    // return desired position
    return {x: 0 , y: 0}
  }

})

// router.beforeEach((to, from, next) => {
//   window.scrollTo(0, 0)
// })

export default router
